import React from 'react'
import styled from 'styled-components'

import { color } from 'styles/colors'

type Props = React.PropsWithChildren<{
  areAllSeriesSelected: boolean
  areNoSeriesSelected: boolean
  onClickSelectAllCallback: (e) => void
  label: string
}>

const LegendGroupSection = ({ label, areAllSeriesSelected, areNoSeriesSelected, children, onClickSelectAllCallback }: Props) => {
  return (
    <div>
      <S.LegendLabel>{label}</S.LegendLabel>
      <S.GroupSelection>
        <S.SelectLabel >Select</S.SelectLabel>
        <S.SelectionOptions>
          <S.SelectionButton selected={areAllSeriesSelected} onClick={() => onClickSelectAllCallback(true)}> all</S.SelectionButton>
          <S.SelectionButton selected={areNoSeriesSelected} onClick={() => onClickSelectAllCallback(false)}>none</S.SelectionButton>
        </S.SelectionOptions>
      </S.GroupSelection>
      <S.Series>
        {children}
      </S.Series>
    </div>
  )
}

export default LegendGroupSection

const S = {
  LegendLabel: styled.span`
    font-weight: bold;
    margin-left: 4px;
`,
  GroupSelection: styled.div`
    float: right;
  `,
  SelectLabel: styled.div`
    float: left;
    margin-right: 11px;
    color:  ${color('rthLegendBorderHover')};
  `,
  SelectionOptions: styled.div`
    float: right;
    margin-top: -1px;
  `,
  SelectionButton: styled.button.withConfig({
    shouldForwardProp: (prop) => !['selected'].includes(prop)
  })<{ selected?: boolean }>`
    min-width: auto;
    padding: 5px 6px 2px 6px;
    display: inline;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    border: none;
    font-weight: inherit;
    font-size: 13px;
    text-transform: capitalize;
    margin: 0 5px 0 0;
    background: ${color('secondaryButton')};
    color: ${({ selected }) => selected ? color('selectedRthLegendControl') : color('rthLegendControl')};
    background-color: ${({ selected }) => selected ? color('rthLegendControlBackground') : color('paneBackground')};
    cursor: ${({ selected }) => selected ? 'initial' : 'pointer'};

    &:hover {
      background-color: ${({ selected }) => selected ? color('rthLegendControlBackground') : color('rthLegendControlBackgroundHover')};
    }
  `,
  Series: styled.div`
    padding: 13px;
    border: 1px solid ${color('border')};
    border-radius: 4px;
  `
}
